<template>
    <div class="app">
        <AppHeader fixed style="background-color: #428bca">
            <b-link class="navbar-brand" to="#" style="color: #fff; font-weight: bold; width: auto;" v-if="!hasLogo">
                {{suiteName}}
            </b-link>
            <b-link class="navbar-brand" to="#"  style="align-items: start; justify-content: start" v-if="hasLogo">
                <img class="navbar-brand-full" :src="imgSrc" style="height: 53px"  alt="Logo">
            </b-link>
        </AppHeader>
        <div class="app-body" style="position: absolute; top: 55px; bottom: 0; left: 0; right: 0; margin: 0">
            <main class="main" style="background-color: #fff">
                <div class="container-fluid" style="padding: 0px; height: 100%">
                    <router-view id="router_view" ref="router_view" :key="$route.fullPath"></router-view>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import {
        Header as AppHeader,
    } from '@coreui/vue'
    import { EventBus } from '../shared/eventbus';


    export default {
        name: 'DefaultContainer',
        components: {
            AppHeader,
        },
        mounted: function () {
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            window.addEventListener('resize', () => {
                // We execute the same script as before
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            });
            EventBus.$on('suite-name', this.onEvent);
        },
        beforeDestroy() {
            // removing eventBus listener
            EventBus.$off('suite-name')
        },
        data() {
            return {
                hasLogo: false,
                imgSrc: "",
                suiteName: "Mängelmelder"
            }
        },
        methods: {
            onEvent(suiteName) {
                this.suiteName = suiteName;
            }

        },
        computed: {
            name() {
                return this.$route.name
            },
            list() {
                return this.$route.matched.filter((route) => route.name || route.meta.label)
            }
        }
    }
</script>

<style>
    .app-header .navbar-brand {
        width: auto !important;
        margin-left: 15px;
    }

    @media (max-width: 991.98px) {
        .app-header .navbar-brand {
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -77.5px;
        }
    }
    .app {
        height: 100%;
        min-height: 100%;
    }

</style>

<style scoped>
    .breadcrumb {
        margin-bottom: 0rem;
    }
</style>
